import type { IconNode } from '../types';

/**
 * @name option
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgM2g3IiAvPgogIDxwYXRoIGQ9Ik0zIDNoNS4yOGExIDEgMCAwIDEgLjk0OC42ODRsNS41NDQgMTYuNjMyYTEgMSAwIDAgMCAuOTQ5LjY4NEgyMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/option
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Option: IconNode = [
  ['path', { d: 'M14 3h7' }],
  ['path', { d: 'M3 3h5.28a1 1 0 0 1 .948.684l5.544 16.632a1 1 0 0 0 .949.684H21' }],
];

export default Option;
